export default "__VITE_ASSET__BDyU5b5$__"